// 슬롯 키는 코어가 소유한다 — 플러그인은 새 자리를 만들지 못하고 여기 열린 자리에만 기여한다 (ADR-048 D3)
// app.header — 모든 화면 머리말 오른쪽(로그인 상태 등). serial 이 로그인 위젯을 여기로 옮긴다 (composition/plugin-config.ts)
export const SLOT_KEYS = ['home.main', 'home.aside', 'app.header'] as const;

export type SlotKey = (typeof SLOT_KEYS)[number];
